import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function AutomatedQuotationAgent() {
  useEffect(() => {
    // Only load script if it hasn't been loaded yet
    if (!document.getElementById("wxo-loader-script")) {
      window.wxOConfiguration = {
        orchestrationID:
          "70d163a79ddf4e54925d1e85aca292ea_c57ab471-e099-4df6-82e3-1f9dd0d7e05a",
        hostURL: "https://au-syd.watson-orchestrate.cloud.ibm.com",
        rootElementID: "auto-orchestrate-chat-root", // must match div below
        deploymentPlatform: "ibmcloud",
        crn: "crn:v1:bluemix:public:watsonx-orchestrate:au-syd:a/70d163a79ddf4e54925d1e85aca292ea:c57ab471-e099-4df6-82e3-1f9dd0d7e05a::",
        chatOptions: {
          agentId: "7135b887-7f71-485b-924f-4433b0e0197a",
          agentEnvironmentId: "adf2d25c-af00-4459-82e0-51380135caec",
        },
      };

      const script = document.createElement("script");
      script.id = "wxo-loader-script";
      script.src = `${window.wxOConfiguration.hostURL}/wxochat/wxoLoader.js?embed=true`;
      script.async = true;
      script.onload = () => {
        if (window.wxoLoader) {
          window.wxoLoader.init();
        }
      };
      document.body.appendChild(script);
    } else {
      // If script already exists, just re-init the chat
      if (window.wxoLoader) window.wxoLoader.init();
    }

    return () => {
      // Clean up: remove chat content only, don't remove script to prevent blank div
      const chatRoot = document.getElementById("auto-orchestrate-chat-root");
      if (chatRoot) chatRoot.innerHTML = "";
    };
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div
        className="text-center text-white bg_header mb-5"
        style={{
          background:
            "url('https://images.pexels.com/photos/5673488/pexels-photo-5673488.jpeg') center/cover",
          padding: "180px 0",
        }}
      >
        <h1 className="fw-bold mb-4">
          <span className="primary_text">Automated Quotation Agent</span>
        </h1>
        <p className="mb-5">
          Accelerate sales cycles and reduce manual effort with{" "}
          <span className="primary_text">AI-driven quotation automation</span>.
        </p>
      </div>

      {/* Features Section */}
      <div className="container mt-5">
        <div className="row text-center invoice_box">
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>⚡ Instant Quote Generation</h4>
              <p>Create accurate, customized quotations in seconds.</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>🔗 System Integration</h4>
              <p>Seamlessly integrates with CRM and ERP systems.</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>📊 Smart Pricing</h4>
              <p>Leverages AI to suggest competitive and optimized pricing.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Advantages Section */}
      <div className="container my-5">
        <h2 className="text-center mb-4">🌟 Advantages</h2>
        <div className="row text-center">
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Faster Turnaround</h5>
              <p>Respond to customer inquiries instantly with ready quotes.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Accuracy</h5>
              <p>Eliminate manual errors and maintain consistent pricing.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Scalability</h5>
              <p>Handle thousands of quotation requests automatically.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Customer Satisfaction</h5>
              <p>Improve response times and enhance client experience.</p>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="container my-5">
        <h2 className="text-center mb-4">⚙️ How It Works</h2>
        <div className="row">
          <div className="col-md-4 text-center">
            <h5>1️⃣ Data Input</h5>
            <p>Receives requirements from CRM, email, or chat.</p>
          </div>
          <div className="col-md-4 text-center">
            <h5>2️⃣ AI Processing</h5>
            <p>Analyzes requirements, pricing rules, and discount policies.</p>
          </div>
          <div className="col-md-4 text-center">
            <h5>3️⃣ Automated Quotation</h5>
            <p>Generates a professional, ready-to-send quotation instantly.</p>
          </div>
        </div>
      </div>

      {/* Agentic AI Section */}
      <div className="container my-5">
        <div className="card shadow-lg p-4">
          <h3 className="text-center mb-3">🤖 Role of Agentic AI</h3>
          <p className="text-center mb-4">
            Agentic AI transforms quotations from static documents into{" "}
            <strong>dynamic, intelligent workflows</strong>.
          </p>
          <ul>
            <li>🔔 Auto-approves standard quotes without human intervention.</li>
            <li>📧 Sends personalized follow-ups to clients instantly.</li>
            <li>🔄 Learns from win/loss history to improve pricing strategies.</li>
            <li>🧠 Acts as a digital sales assistant for your team.</li>
          </ul>
        </div>
      </div>

      {/* Watson Chat Embed */}
      <div className="container my-5">
        <div className="card shadow-lg p-4">
          <h3 className="text-center mb-3">Interact with the Quotation Agent</h3>
          <p className="text-center">
            Ask for quotes, simulate pricing, and explore quotation strategies instantly.
          </p>
          <div
            id="auto-orchestrate-chat-root"
          ></div>
        </div>
      </div>
    </div>
  );
}

export default AutomatedQuotationAgent;
